import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { KEY_LOCAL_STORAGE, setGlobalClassTheme } from '@/helpers/theme';
import { ThemeMode } from '@/interfaces/theme';

interface ThemeState {
  mode: ThemeMode;
  subdomain: {
    dark: string;
    light: string;
  } | null;
}

const initialState: ThemeState = {
  mode: window.localStorage.getItem(KEY_LOCAL_STORAGE) === 'light' ? 'light' : 'dark',
  subdomain: null
};

export const themeSlice = createSlice({
  name: 'themeSlice',
  initialState,
  reducers: {
    setSubdomainTheme(state, action: PayloadAction<ThemeState['subdomain']>) {
      return {
        ...state,
        subdomain: action.payload
      };
    },
    toggleTheme(state) {
      const mode = state.mode === 'dark' ? 'light' : 'dark';
      window.localStorage.setItem(KEY_LOCAL_STORAGE, mode);
      setGlobalClassTheme(mode);
      return { ...state, mode };
    }
  }
});

export const { toggleTheme, setSubdomainTheme } = themeSlice.actions;

export default themeSlice.reducer;
